module.exports = __webpack_public_path__ + "img/10 export.95ae7b77.jpeg";